import Vue from 'vue'

const ROLE_VALUE_OF_DEFAULT = "default"

document.addEventListener('DOMContentLoaded', () => {
  const userForm = document.getElementById('user-form')
  if (userForm) {
    new Vue({
      el: "#form",
      data: {
        ...JSON.parse(userForm.dataset.props),
        ...{ role: "", selected: {} }
      },
      mounted() {
        // writeback group_ids
        for (const v of this.writeback_group_ids) {
          this.$set(this.selected, v, true)
        }
        // writeback role
        this.role = this.writeback_role
      },
      computed: {
        groups() {
          if (this.branch) {
            return this.branches[this.branch].groups
          } else {
            return []
          }
        },
        canSignature() {
          return ROLE_VALUE_OF_DEFAULT !== this.role
        },
      }
    })
  }
})